import { render } from "./ValueChangeActivityBadge.vue?vue&type=template&id=2ce96abc&scoped=true"
import script from "./ValueChangeActivityBadge.vue?vue&type=script&lang=js"
export * from "./ValueChangeActivityBadge.vue?vue&type=script&lang=js"

import "./ValueChangeActivityBadge.vue?vue&type=style&index=0&id=2ce96abc&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2ce96abc"

export default script